import { render, staticRenderFns } from "./store-config.vue?vue&type=template&id=9e09d224"
import script from "./store-config.vue?vue&type=script&lang=js"
export * from "./store-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports